// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__13UUi","title":"Images90_title__2xq0J","images":"Images90_images__31GSV"};